module.exports = __webpack_public_path__ + "static/more-0b834062a4a788bcc93b462f2e148ca7.png";